import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Calendar } from 'lucide-react';
import { BlogPostData } from '@/data/blogPosts';

interface RelatedPostsProps {
  posts: BlogPostData[];
  className?: string;
}

const RelatedPosts = ({ posts, className = '' }: RelatedPostsProps) => {
  if (posts.length === 0) return null;

  return (
    <section className={`${className}`}>
      <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-8">
        Related Articles
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map((post, index) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group bg-card rounded-2xl border border-border overflow-hidden hover:border-primary/30 hover:shadow-apple-md transition-all opacity-0 animate-fade-in"
            style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'forwards' }}
          >
            <div className="p-5">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2.5 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
                  {post.category}
                </span>
              </div>
              
              <h3 className="text-base font-semibold text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors">
                {post.title}
              </h3>
              
              <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
                {post.excerpt}
              </p>
              
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" />
                    {new Date(post.date).toLocaleDateString('en-IN', { 
                      day: 'numeric', 
                      month: 'short'
                    })}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    {post.readTime}
                  </span>
                </div>
                <ArrowRight className="w-4 h-4 text-primary opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;
